var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"meeting-container align-center justify-center"},[_c('v-icon',{staticClass:"meeting-loading",attrs:{"size":"100"}},[_vm._v("mdi-loading ")]),_c('div',[_vm._v(_vm._s(_vm.$t("commons.connecting"))+"...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }